<app-button
    [disabled]="!canManageOrganization()"
    [label]="organization()!.name"
    [matTooltip]="(canManageOrganization() ? 'manageOrganization' : 'noAccessOrganization') | transloco"
    [type]="ButtonType.SECONDARY"
    (onClick)="redirectToManagementOrganizationPanel()" />
